export default __webpack_public_path__ + "static/media/logoColored.42462ce6.svg";